export default {
  LIST: {
    TITLE: `Liste des modèles d'horaire`
  },
  LIST_PROJECT: {
    TITLE: `Liste des modèles d'horaire pour {{ project }}`,
    SUMMARY: `Seulement les modèles d'horaire du projet sélectionné sont visibles sur cette page, allez sur la page générale des modèles d'horaire pour voir les autres.`
  },
  LIST_PROJECT_SIMPLE: {
    TITLE: `Liste des modèles d'horaire pour {{ project }}`,
    SUMMARY: ``
  },
  CREATE: `Créer un modèle d'horaire`,
  APPLY: `Appliquer à l'horaire`,
  COPY: `Copie`,
  DUPLICATE: `Dupliquer`,
  EMPLOYEE_SELECTION_TOOL: `Outil de sélection d'employés`,
  SAVE: `Enregistrer les quarts de travail`,
  DAY_HEADER: `Jour {{ multiDayIndex }}`,
  NUMBER_OF_DAYS: `Modèle d'un jour`,
  NUMBER_OF_DAYS_other: `Modèle de {{ count }} jours`,
  EVENT_SUMMARY: `<0>{{ name }}</0> - {{ positionName }} <1>(Jour {{ multiDayIndex }}, {{ start }} - {{ end }})</1>`,
  SELECT_ALL: `Tout sélectionner`,
  UNSELECT_ALL: `Tout déselectionner`,
  TEMPLATE_DELETED: `Le modèle d'horaire sélectionné n'existe plus.`,
  ARCHIVED: `Archivé`,
  ARCHIVE: `Archiver`,
  UNARCHIVE: `Désarchiver`,
  IMPORT_SCHEDULE_TEMPLATE: `Importer un modèle d'horaire`,
  form: {
    EDIT: {
      TITLE: `Modifier un modèle d'horaire ({{ name }})`,
      SUMMARY: ``
    },
    CREATE: {
      TITLE: `Créer un modèle d'horaire`,
      SUMMARY: ``
    },
    MULTI_CREATION: `Création multiple`,
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez un nom`,
      DESCRIPTION: `Sert à identifier le modèle d'horaire`
    },
    COMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Entrez un commentaire`,
      DESCRIPTION: `Sert à ajouter des informations supplémentaires au modèle d'horaire.`
    },
    REQUIREDPOSITIONS: {
      LABEL: `Positions requises`,
      PLACEHOLDER: `Sélectionnez une ou plusieures positions`,
      DESCRIPTION: `Sert à déterminer à quelles positions pourront être assignés les quarts de travail dans ce modèle d'horaire. Sert également à filtrer toutes les autres positions lors de l'édition du modèle.`
    },
    DEFAULTSHIFTCOMMENT: {
      LABEL: `Commentaire de quart par défaut`,
      PLACEHOLDER: `Entrez un commentaire`,
      DESCRIPTION: `Sert à ajouter un commentaire par défaut à tous les quarts qui n'en ont pas lors de l'application à l'horaire. Ce champ supporte les traductions en utilisant #fr et #en. `
    },
    DEFAULTSHIFTTAGS: {
      LABEL: `Étiquettes de quart par défaut`,
      PLACEHOLDER: `Sélectionnez une ou plusieures étiquettes`,
      DESCRIPTION: `Sert à ajouter des étiquettes de quart par défaut à tous les quarts qui n'en ont pas lors de l'application à l'horaire`
    },
    COMBINESHIFTANDTEMPLATETAGS: {
      LABEL: `Combiner les étiquettes par défaut et ceux des quarts de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Lorsque actif, les étiquettes par défaut et celles assignées aux quarts de travail individuels seront combinées, incluant celles venant d'un projet.`
    },
    DEPARTMENTS: {
      LABEL: `Départements`,
      PLACEHOLDER: `Sélectionnez un ou plusieurs départements`,
      DESCRIPTION: `Sert à indiquer à quels départements appartient ce modèle d'horaire.`
    },
    ALLSHIFTSIRREPLACEABLE: {
      LABEL: `Marquer tous les quarts de travail comme étant irremplaçables.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Lorsque actif, tous les quarts de travail de ce modèle appliqués à l'horaire seront marqués comme irremplaçables.`
    },
    MULTIDAYINDEX: {
      LABEL: `Jour dans le modèle`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à déplacer le quart d'un jour à un autre dans le modèle.`,
      OPTION: `Jour {{ day }}`
    },
    NUMBEROFIDENTICAL: {
      LABEL: `Nombre de quarts identiques`,
      PLACEHOLDER: `Entrez un nombre`,
      DESCRIPTION: `Sert à créer plusieurs quarts identiques, par exemple entrer 5 créera 5 quarts de travail identiques dans le modèle d'horaire.`
    },
    ADDTOOTHERDAYS: {
      LABEL: `Ajouter à plusieurs jours`,
      PLACEHOLDER: `Sélectionnez un ou plusieurs jours`,
      DESCRIPTION: `Sert à ajouter un quart similaire sur plusieurs jours, peut être combiné avec le nombre de quarts identiques afin de créer un ensemble de quarts similaires sur plusieurs jours du modèle d'horaire.`
    },
    PROJECTS: {
      LABEL: `Projet`,
      PLACEHOLDER: `Sélectionnez un projet`,
      DESCRIPTION: `Sert à indiquer si un modèle d'horaire fait parti d'un projet, cache le modèle d'horaire de la liste à moins que le projet soit cherché explicitement dans le barre de recherche. Tous les quarts provenant de ce modèle d'horaire seront lié au projet.`
    },
    TEAM: {
      LABEL: `Équipe`,
      PLACEHOLDER: `Sélectionnez une équipe`,
      DESCRIPTION: `Sert à indiquer si un modèle d'horaire fait parti d'une équipe. Tous les quarts provenant de ce modèle d'horaire seront lié à l'équipe.`
    },
    BULK_SHIFT_CREATE: {
      TITLE: `Création de quarts`,
      NO_REQUIRED_POSITIONS: `Il n'y a aucune position requise dans ce modèle d'horaire, ajoutez en afin d'utiliser l'outil de création de quarts.`,
      BULKSTARTTIME: {
        LABEL: `Heure de début`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à créer de quarts selon une heure de début prédéfinie.`
      },
      BULKENDTIME: {
        LABEL: `Heure de fin`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à créer de quarts selon une heure de fin prédéfinie.`
      },
      AMOUNT: {
        LABEL: `Quantité`,
        PLACEHOLDER: ``,
        DESCRIPTION: ``
      },
      BULKSCHEDULETYPE: {
        LABEL: `Type de quart`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à rapidement sélectionner un type de quart prédéfini.`
      }
    },
    FIELD_MANDATORY: `Ce champ est obligatoire.`
  },
  DATES_MODAL: {
    TITLE: `Dates appliquées`,
    SUMMARY: `Montre quels quarts de travail à l'horaire proviennent de ce modèle d'horaire.`,
    POSITION_DETAIL_other: `<0>{{ count }}</0> quarts de travail à <0>{{ positionName }}</0>`,
    POSITION_DETAIL: `<0>{{ count }}</0> quart de travail à <0>{{ positionName }}</0>`
  },
  IMPORT_FROM_SCHEDULE: `Importer des quarts de travail de l'horaire`,
  IMPORT_SCHEDULE_MODAL: {
    TITLE: `Importer de l'horaire`,
    SUMMARY: `Permet d'importer des quarts de travail se trouvant déjà à l'horaire à une date spécifique.`,
    DESCRIPTION: `Seulement les quarts de travail assignés aux positions requises de ce modèle d'horaire seront importés.`,
    ERROR_IMPORTING: `Erreur d'importation, veuillez ressayer.`,
    DATE: {
      LABEL: `Date`,
      PLACEHOLDER: `Veuillez sélectionner une date`,
      DESCRIPTION: `Sert à déterminer de quelle date dans l'horaire les quarts de travail importés vont provenir.`
    },
    KEEPASSIGNEDEMPLOYEES: {
      LABEL: `Garder les employés assignés`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si inactif, les employés préalablement assignés aux quarts seront enlevés avant l'importation.`
    },
    IMPORTONLYFROMTHISTEMPLATE: {
      LABEL: `Importer seulement les quarts provenant de ce modèle.`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si actif, tous les quarts ne provenant pas de ce modèle d'horaire seront omis lors de l'importation.`
    }
  },
  employeeSelectionTool: {
    USE: `Utiliser l'outil de sélection d'employés`,
    MODAL: {
      TITLE: `Outil de sélection d'employés`,
      SUMMARY: `Sert à trouver des employés éligibles pour le modèle à l'aide de filtres.`
    },
    form: {
      FILTERELIGIBLEEMPLOYEES: {
        LABEL: `Afficher seulement les employés éligibles`,
        DESCRIPTION: ``
      },
      DATESTOCHECK: {
        LABEL: `Dates à vérifier`,
        PLACEHOLDER: `Sélectionnez au moins une date`,
        DESCRIPTION: `Sert à valider que les employés sont disponibles sur des dates spécifiques et qu'ils ne sont pas déjà à l'horaire, en congé ou contraint par d'autres problèmes.`
      },
      ATTRIBUTES: {
        LABEL: `Attributs`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à filtrer les employés selon leurs attributs et s'assurer qu'ils ont tous les requis/compétences et aucune restriction.`
      },
      REGIONS: {
        LABEL: `Régions`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à filtrer les employés selon leur région.`
      },
      PROJECTS: {
        LABEL: `Projets`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à filtrer les employés selon les projets auxquels ils sont affectés.`
      },
      SELECTEDSORT: {
        LABEL: `Ordre de tri`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à trier les employés selon un ordre de tri pré-défini.`
      },
      SELECTEDFILTER: {
        LABEL: `Filtre`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Sert à filtrer les employés selon une configuration de filtre pré-défini.`
      }
    },
    TOO_MANY_USERS_SELECTED: `Vous avez sélectionné plus d'employés que de quarts de travail disponible, les derniers employés sélectionnés ne seront pas assignés.`,
    SOME_SHIFTS_ASSIGNED: `Certains quarts sélectionnés sont déjà assignés à des employés, ils seront réassignés.`,
    LOAD_EMPLOYEES: `Charger les employés`,
    ELIGIBLE: `Éligible`,
    NOT_ELIGIBLE: `N'est pas éligible`,
    LOCKED_TO_CURRENT_PROJECT: `Vérouillé sur le projet actuel`,
    LOCKED_TO_OTHER_PROJECT: `Vérouillé sur un autre projet`,
    PREFERRED_CURRENT_PROJECT: `Préféré sur le projet actuel`,
    PREFERRED_OTHER_PROJECT: `Préféré sur un autre projet`,
    INVALID_EMPLOYEE_STATUS: `Statut d'employé invalide`,
    INVALID_EMPLOYEE_TYPE: `Type d'employé invalide`,
    UNAVAILABLE: `Non-disponible cette journée`,
    UNAVAILABLE_RANGE: `Non disponible de {{ start }} à {{ end }}`,
    AVAILABLE_RANGE: `Disponible de {{ start }} à {{ end }}`,
    PREFERRED_RANGE: `Préfère travailler de {{ start }} à {{ end }}`,
    EVENT_OVERLAPPING: `Travaille déjà à la position {{ positionName }} de {{ start }} à {{ end }}`,
    EVENT_OVERLAPPING_PROJECT: `Travaille déjà à la position {{ positionName }} de {{ start }} à {{ end }} sur le projet {{ projectName }}`,
    ASSIGN_EMPLOYEES: `Assigner les employés sélectionnés`,
    ALREADY_IN: `Déjà assigné au modèle`,
    UNASSIGNED_SHIFTS: `Quarts non-assignés`,
    ASSIGNED_SHIFTS: `Quarts assignés`,
    ALREADY_IN_MULTI: `Déjà assigné au modèle au jour {{ days }}`,
    ALREADY_IN_MULTI_other: `Déjà assigné au modèle aux jours {{ days }}`,
    ISSUES: `Problèmes`,
    VIEW_LESS: `Voir moins de problèmes`,
    VIEW_MORE: `Voir {{ count }} autre problème`,
    VIEW_MORE_other: `Voir {{ count }} autres problèmes`,
    PROJECT_EXPERIENCE: `Expérience sur le projet: {{ totalProjectExperience }}h`,
    RELATED_PROJECT_EXPERIENCE: `Expérience sur les projets associés: {{ totalRelatedProjectExperience }}h`
  },
  EDIT_TEMPLATE_INFO: `Modifier les informations`,
  TEMPLATE_INFO_MODAL: {
    TITLE: `Modifier les informations`,
    SUMMARY: `Permet de mettre des valeurs par défaut à tous les quarts de travail dans le modèle ainsi que modifier les propriétés du modèle.`
  },
  DELETE_BUTTON: {
    TITLE: `Supprimer ce modèle`,
    SUMMARY: `Êtes vous certain de vouloir supprimer ce modèle?`,
    PRIMARY_ACTION: `Supprimer`
  },
  SCHEDULE_TEMPLATE_APPLY_MODAL: {
    TITLE: `Appliquer un modèle à l'horaire`,
    SUMMARY: ``
  },
  CONTEXT_MENU: {
    EDIT: `Modifier`,
    DELETE: `Supprimer`,
    REMOVE_EMPLOYEE: `Retirer l'employé`,
    TOGGLE_OVERTIME: `Basculer le statut de temps supplémentaire`,
    TOGGLE_VARIABLE_END_TIME: `Basculer le statut de l'heure de fin variable`,
    EMPLOYEE_SELECTION_TOOL: `Combler avec l'outil de sélection d'employés`,
    SELECTED: `{{ count }} quart de travail sélectionné`,
    SELECTED_other: `{{ count }} quarts de travail sélectionnés`
  },
  applyForm: {
    MULTI_SELECT: `Selection rapide`,
    OPTIONS: `Options`,
    LOAD_DATES: `Ajouter aux champ des dates à appliquer`,
    LOAD_APPLIED_DATES: `Charger les dates auxquels le modèle est déjà appliqué`,
    REMOVE_ALL_DATES: `Enlever toutes les dates`,
    FINE_TUNE: `Ajuster les dates`,
    ERROR_APPLYING_TEMPLATE: `L'application du modèle d'horaire a échoué.`,
    NUMBER_OF_DATES_SELECTED_PAST: `Vous avez sélectionné <0>{{ count }}</0> date dans le passé sans désactiver l'option de seulement appliquer dans le future.`,
    NUMBER_OF_DATES_SELECTED_PAST_other: `Vous avez sélectionné <0>{{ count }}</0> dates dans le passé sans désactiver l'option de seulement appliquer dans le future.`,
    NEW_DATES: `<0>{{ count }}</0> nouvelles date va être appliquée à l'horaire.`,
    NEW_DATES_other: `<0>{{ count }}</0> nouvelles dates vont être appliquées à l'horaire.`,
    MODIFIED_DATES: `<0>{{ count }}</0> date existante va être mise à jour à l'horaire.`,
    MODIFIED_DATES_other: `<0>{{ count }}</0> dates existantes vont être mises à jour à l'horaire.`,
    DELETED_DATES: `<0>{{ count }}</0> date existante va être enlevée de l'horaire.`,
    DELETED_DATES_other: `<0>{{ count }}</0> dates existantes vont être enlevées de l'horaire.`,
    DATESTOAPPLY: {
      LABEL: `Dates à appliquer`,
      PLACEHOLDER: `Sélectionnez des dates`,
      DESCRIPTION: `Sert à préciser à quelles dates dans l'horaire ce modèle doit être appliqué, créant ou modifiant les quarts au besoin.`
    },
    MODIFIEDDATES: {
      LABEL: `Dates à modifier`,
      PLACEHOLDER: `Aucune date à modifier sélectionnée`,
      DESCRIPTION: `Sert à ajuster quelles dates seront modifiées dans l'horaire une fois le modèle appliqué.`
    },
    DELETEDDATES: {
      LABEL: `Dates à supprimer`,
      PLACEHOLDER: `Aucune date à supprimer sélectionnée`,
      DESCRIPTION: `Sert à ajuster quelles dates seront supprimées dans l'horaire une fois le modèle appliqué.`
    },
    NEWDATES: {
      LABEL: `Dates à ajouter`,
      PLACEHOLDER: `Sélectionnez des dates`,
      DESCRIPTION: `Sert à ajuster quelles dates seront ajoutées dans l'horaire une fois le modèle appliqué.`
    },
    MULTISELECTRANGE: {
      LABEL: `Période`,
      PLACEHOLDER: `Sélectionnez une période`,
      DESCRIPTION: `Sert à établir la période sur laquelle les dates seront sélectionnées dans les dates à appliquer. `
    },
    MONDAY: { LABEL: `Lun` },
    TUESDAY: { LABEL: `Mar` },
    WEDNESDAY: { LABEL: `Mer` },
    THURSDAY: { LABEL: `Jeu` },
    FRIDAY: { LABEL: `Ven` },
    SATURDAY: { LABEL: `Sam` },
    SUNDAY: { LABEL: `Dim` },
    DAY_OF_WEEK_DESCRIPTION: `Sert à établir quelles journées de la semaine seront sélectionnées.`,
    DELETESHIFTS: {
      LABEL: `Supprimer les quarts`,
      DESCRIPTION: `Si actif, les quarts appartenant à ce modèle sur les dates sélectionnées seront effacés.`
    },
    APPLYINFUTURE: {
      LABEL: `Appliquer dans le futur`,
      DESCRIPTION: `Si actif, seulement les journées dans le futur seront modifiés, les quarts ne seront pas appliqués sur des dates dans le passé.`
    },
    DONTUPDATEUSERS: { LABEL: `Ne pas modifier les utilisateurs assignés`, DESCRIPTION: `` },
    DONTUPDATETAGS: { LABEL: `Ne pas modifier les étiquettes du quart`, DESCRIPTION: `` },
    DONTUPDATECOMMENTS: { LABEL: `Ne pas modifier les commentaires`, DESCRIPTION: `` },
    DONTUPDATETIME: { LABEL: `Ne pas modifier les heures`, DESCRIPTION: `` }
  },
  MULTI_DAY: `Multi-jours`,
  NAME: `Nom`,
  COMMENT: `Commentaire`,
  TEAM: `Équipe`,
  DEFAULTSHIFTCOMMENT: `Commentaire de quart par défaut`,
  CREATEDBY: `Créé par`,
  CREATIONDATE: `Créé le`,
  LASTUPDATEBY: `Mis à jour par`,
  LASTUPDATEDATE: `Mis à jour le`,
  DEFAULTSHIFTTAGS: `Étiquettes de quart par defaut`,
  DEPARTMENTS: `Départements`,
  REQUIREDPOSITIONS: `Positions requises`,
  SHIFTS: `Quarts`,
  ALLSHIFTSIRREPLACEABLE: `Tous les quarts sont irremplaçables`,
  APPLIED_FROM: `À l'horaire du {{ firstDate }} au {{ lastDate }}`,
  NOT_APPLIED: `N'est pas à l'horaire`,
  import: {
    TITLE: `Importer un modèle d'horaire`,
    TEMPLATE_FIELDS: `Champs d'import pour le modèle`,
    TEMPLATE_EVENT_FIELDS: `Champs d'import pour les quarts dans le modèle`,
    FILENAME: `import_modele_horaire`,
    NAME: `Nom`,
    NAME_DESC: `Nom du modèle d'horaire`,
    PROJECTCODE: `Projet`,
    PROJECTCODE_DESC: `Doit être un projet existant avec un code.`,
    DEFAULTSHIFTTAGS: `Étiquettes de quart par défaut`,
    DEFAULTSHIFTTAGS_DESC: `Doit être une liste de codes d'import d'étiquettes existantes. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    DEPARTMENTS: `Départements`,
    DEPARTMENTS_DESC: `Doit être une liste de codes d'import de départments existants. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    REQUIREDPOSITIONS: `Positions requises`,
    REQUIREDPOSITIONS_DESC: `Doit être une liste de codes d'import d'étiquettes existantes. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    COMMENT: `Commentaire`,
    COMMENT_DESC: `Commentaire servant à décrire le modèle d'horaire.`,
    DEFAULTSHIFTCOMMENT: `Commentaire de quart par défaut.`,
    DEFAULTSHIFTCOMMENT_DESC: `Commentaire qui sera attribué à chaque quart dans le modèle. Entrer un '<0>X</0>' dans la cellule signifie <0>OUI</0>, la laisser vide signifie <0>NON</0>.`,
    ALLSHIFTSIRREPLACEABLE: `Tous les quarts sont irremplaceables`,
    ALLSHIFTSIRREPLACEABLE_DESC: `Détermine si oui ou non tous les quarts dans le modèle sont irremplaceables (Mêmes instructions que <0>defaultShiftComment</0>).`,
    COMBINESHIFTANDTEMPLATETAGS: `Combiner les étiquettes de quart et modèle`,
    COMBINESHIFTANDTEMPLATETAGS_DESC: `Détermine si les étiquettes du quart et du modèles doivent être combinés (Mêmes instructions que <0>defaultShiftComment</0>).`,
    STARTTIME: `Heure de début`,
    STARTTIME_DESC: `L'heure de début doit être inscrite dans le format suivant : <1>HH:mm</1>, par exemple <1>08:00</1> pour 8h.`,
    ENDTIME: `Heure de fin`,
    ENDTIME_DESC: `L'heure de fin doit être inscrite dans le format suivant : <1>HH:mm</1>, par exemple <1>17:00</1> pour 17h.`,
    DAYINTEMPLATE: `Jour dans le modèle`,
    DAYINTEMPLATE_DESC: `Si le modèle comporte plusieurs jours, indique le jour dans le modèle où le quart se situe.`,
    VALIDATION: `Validation`
  }
}
